type PaneInput = { wide: boolean; pinnedId: string | null; activeId: string | null; closedId: string | null };

/**
 * Which order the wide Home shows beside the list. The home poll can keep reporting an order for a few
 * seconds after it was delivered or released, so the one the shipper just closed stays closed.
 */
export const deliveryPaneId = ({ wide, pinnedId, activeId, closedId }: PaneInput): string | null => {
  if (pinnedId) return pinnedId;
  return wide && activeId && activeId !== closedId ? activeId : null;
};
